import {
  IconArticle,
  IconBook2,
  // IconHeadphones,
  IconInbox,
  IconLayoutGrid,
  // IconVideo,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { IconCollection } from "../../../components/icons/IconCollection";
import { TabButton } from "../../../components/ui/TabButton";
import type { SearchCategory } from "../types";

export function SearchCategoryTabs({
  active,
  onChange,
}: {
  active: SearchCategory;
  onChange: (next: SearchCategory) => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const tabs: ReadonlyArray<{
    value: SearchCategory;
    label: string;
    Icon: typeof IconInbox;
  }> = [
    { value: "all", label: t("All"), Icon: IconInbox },
    { value: "articles", label: t("Articles"), Icon: IconArticle },
    { value: "rooms", label: t("Rooms"), Icon: IconLayoutGrid },
    // { value: "podcasts", label: t("Podcasts"), Icon: IconHeadphones },
    // { value: "videos", label: t("Videos"), Icon: IconVideo },
    { value: "playlists", label: t("Playlists"), Icon: IconCollection },
    { value: "journals", label: t("Journals"), Icon: IconBook2 },
  ];
  return (
    <div className="flex w-full items-center gap-3 overflow-x-auto scrollbar-hidden">
      {tabs.map(({ value, label, Icon }) => {
        const isActive = value === active;
        return (
          <TabButton
            key={value}
            active={isActive}
            onClick={() => {
              onChange(value);
            }}
            icon={<Icon className="size-4" />}
          >
            {isActive ? label : ""}
          </TabButton>
        );
      })}
    </div>
  );
}
